import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';
import { CMSService } from '../service/cms.service';
import { CMSMetaData } from '../../../models/cms-data';

@Component({
    selector: 'app-cms-popover',
    templateUrl: './cms-popover.component.html',
    styleUrls: ['./cms-popover.component.scss'],
})
export class CmsPopoverComponent implements OnInit, AfterViewInit {
    @ViewChild('popoverQuestionMark') questionMarkRef: ElementRef;
    @ViewChild('bubble') bubbleRef: ElementRef;

    @Input() cmsPopUp: CMSMetaData;
    @Input() popoverText: string;
    headerText: string;

    isPopoverOpen = false;

    contentText: string = '';
    linkUrl: string = '';
    linkText: string = '';
    size: string = '';
    placeholderContentText: string = 'An error occurred while retrieving this tooltip message. Please try again later.';

    constructor(private cmsService: CMSService) {}

    ngOnInit(): void {
        if(this.popoverText) {
            this.contentText = this.popoverText;
        } else {
            const cmsCall = this.cmsService.cmsCall(this.cmsPopUp.contentId, 'entry');
            if (cmsCall) {
                cmsCall.subscribe(
                    (data) => {
                        this.contentText = data['text']['content'][0]['content'][0].value;
                        if (data['text']['content'][0]['content'][1] !== undefined) {
                            this.linkUrl = data['text']['content'][0]['content'][1]['data'].uri;
                            this.linkText = data['text']['content'][0]['content'][1]['content'][0].value;
                        }
                    }
                );
            }
        }
    }

    ngAfterViewInit(): void {
        this.resizeButton(this.cmsPopUp.size);
    }

    resizeButton(size: string) {
        if (this.questionMarkRef) {
            this.questionMarkRef.nativeElement.style.backgroundSize = `${size}px`;
            this.questionMarkRef.nativeElement.style.height = `${size}px`;
            this.questionMarkRef.nativeElement.style.width = `${size}px`;
        }
    }

    togglePopover() {
        if (this.isPopoverOpen) {
            this.isPopoverOpen = false;
        } else {
            this.isPopoverOpen = true;
            const popover = this.bubbleRef.nativeElement;
            const popoverRect = popover.getBoundingClientRect();
            const questionMarkRect = this.questionMarkRef.nativeElement.getBoundingClientRect();
            const top = questionMarkRect.top - popoverRect.height - 15;
            const left = questionMarkRect.left - (popoverRect.width / 2) + (questionMarkRect.width / 2);

            popover.style.top = `${top}px`;
            popover.style.left = `${left}px`;
        }
    }

    @HostListener('document:click', ['$event'])
    onClick(event) {
        if (event.target !== this.questionMarkRef.nativeElement && event.target.className !== 'popover-link') {
            this.close();
        }
    }

    close() {
        if (this.isPopoverOpen) {
            this.isPopoverOpen = false;
        }
    }

}
